// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__lAkQM","consentsList":"PatientConsents_consentsList__3iJfp","consentsListEmpty":"PatientConsents_consentsListEmpty__3syUi"};